import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/integrations/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import IntegrationsList from "../components/integrations/IntegrationsList";
import Cta from "../components/integrations/Cta";
import Testimonials from "../components/integrations/Testimonials";

const Integrations = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <IntegrationsList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Integrations;
